import { useState, useEffect } from 'react';
import { useTextForm } from '../useTextForm';

export const useWriterTextForm = (formData, orderType, isLoading) => {
  const base = useTextForm(formData, isLoading);
  const [initialTextContent, setInitialTextContent] = useState('');
  const [initialHtmlContent, setInitialHtmlContent] = useState('');

  useEffect(() => {
    if (!formData) return;

    setInitialTextContent(formData.initialTextContent || '');
    setInitialHtmlContent(formData.initialHtmlContent || '');

    if (orderType !== 'PREMIUM' && !formData.actualHtmlContent) {
      base.setActualHtmlContent(formData.actualTextContent || '');
    }
  }, [formData, orderType, isLoading]);

  return {
    ...base,
    initialTextContent,
    initialHtmlContent,
    setInitialTextContent,
    setInitialHtmlContent,
  };
};
